import { useLocation } from "react-router-dom";

export default function AadhaarErrorPage() {
  const query = new URLSearchParams(useLocation().search);
  const message = query.get("message") || "Unknown error occurred.";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white shadow-lg rounded-xl p-8 max-w-md w-full text-center">
        <div className="text-5xl mb-4">⚠️</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Aadhaar Verification Failed
        </h1>
        <p className="text-gray-600 mb-6">{message}</p>
        <button
          onClick={() => (window.location.href = "/start-onboarding")}
          className="px-6 py-3 rounded-lg bg-red-500 text-white font-medium hover:bg-blue-700 transition"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
